import React, { useState, useEffect } from "react";
import styles from "./styles/RichText.module.css";
import stylesSelect from "./styles/SelectField.module.css";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import clsx from "clsx";
import {
  convertToRaw,
  EditorState,
  ContentState,
  convertFromHTML,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import draftToHtml from "draftjs-to-html";
import { stateToHTML } from "draft-js-export-html";

const RichText = ({
  name,
  value,
  onChange,
  placeholder,
  error,
  setFieldError,
  touched,
  setFieldTouched,
}) => {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    if (conditionError()) {
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(value))
        )
      );
    }
  }, [value]);

  const conditionError = () => {
    if (
      (convertToRaw(editorState.getCurrentContent()).blocks.length === 1) ===
        true &&
      (convertToRaw(editorState.getCurrentContent()).blocks[0].text === "") ===
        true
    ) {
      return true;
    } else {
      return false;
    }
  };

  const onEditorStateChange = (e) => {
    setEditorState(e);
    if (conditionError()) {
      onChange("");
    } else {
      onChange(stateToHTML(editorState.getCurrentContent()));
    }
  };

  return (
    <>
      <div
        className={clsx(styles.richTextContainer, styles.editorContainer, {
          // [styles.richTextError]: touched && error,
          [styles.richTextError]: touched && conditionError(),
        })}
      >
        {/* <CKEditor
          id="editor"
          config={{
            placeholder: placeholder,

            // removePlugins: ["Heading", "Link"],
            removePlugins: ["imageUpload", "mediaEmbed"],
          }}
          name={name}
          editor={ClassicEditor}
          data={value}
          onChange={(event, editor) => {
            const data = editor.getData();
            onChange(data);
          }}
          onBlur={() => {
            setFieldError();
            setFieldTouched();
          }}
        /> */}
        <Editor
          className={clsx(styles.editorContainer)}
          name={name}
          editorState={editorState}
          rapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          onEditorStateChange={onEditorStateChange}
          // onEditorStateChange={onChange}
          onBlur={() => {
            setFieldError();
            setFieldTouched();
          }}
          placeholder={placeholder}
          editorStyle={{ padding: "5px 10px" }}
        />
      </div>

      <div className={clsx(stylesSelect.errorText, "text-left")}>
        {/* {touched && error ? error : ""} */}
        {touched && conditionError() ? error : ""}
      </div>
    </>
  );
};

/* required: display name */
RichText.displayName = "RichText";

/* required: props types */
RichText.propTypes = {};

/* required: default props */
RichText.defaultProps = {};

export { RichText };
